<template>
  <div class="channel-two-news">
    <!-- 新闻区块：每 6 条后插入横幅，不足 3 行也在尾部插入 -->
    <div class="news-blocks">
      <template v-for="(block, bIndex) in visibleBlocks">
        <!-- 横幅 -->
        <div
          v-if="block.type === 'banner' && bannerImg"
          :key="'banner-' + bIndex"
          class="banner-wrap"
          @click="goBannerLink"
        >
          <img
            class="banner-image"
            referrerpolicy="no-referrer"
            :src="bannerImg"
            alt="广告横幅"
          />
          <span v-if="bannerShowTag === 1" class="ad-tag">广告</span>
        </div>

        <!-- 新闻网格：一行两个 -->
        <div
          v-else
          :key="'row-' + bIndex"
          class="news-row" 
        >
          <div
            v-for="item in block.items"
            :key="item.id"
            class="news-item"
            :class="{ 'no-image': !item.img }"
          >
            <div class="news-image-wrap"  v-if="item.img" @click="goDetail(item)">
              <img
                class="news-thumb"
                referrerpolicy="no-referrer"
                :src="item.img"
                :alt="item.title"
                @error="handleImageError($event, item.img, item.id)"
                @load="handleImageLoad(item.id)"
                :class="{ 'img-loading': !item.loaded }"
              />
              <span v-if="!item.loaded && item.isLoading" class="img-placeholder">加载中...</span>
            </div>
            <div class="news-content">
              <div class="news-title" @click="goDetail(item)">{{ item.title }}</div>
              <p v-if="!item.img && item.desc" class="news-desc">{{ item.desc }}</p>
               <p v-if="item.img && item.desc" class="news-desc"></p>
              <div class="news-meta">
                <span class="news-category">{{ getSource(item.source) }}</span>
                <span class="news-time">&nbsp;|&nbsp;{{ formatTime(item.time) }}</span>
                <div class="news-actions">
                  <ShareButton :news-code="item.newsCode" :title="item.title" />
                  <FavoriteButton :news-id="item.id" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <!-- 加载更多 / 没有更多 -->
    <div
      v-if="hasMore"
      class="load-more"
      @click="loadMore"
    >
      <img
        class="load-icon"
        referrerpolicy="no-referrer"
        :src="loadIcon"
      />
      <span v-if="!loading">点击加载更多</span>
      <span v-else>加载中...</span>
    </div>
    <div v-if="!hasMore && allNews.length > 0" class="no-more">
      <span>没有更多新闻数据</span>
    </div>
  </div>
</template>

<script>
import { fetchAdDetails, resolveAdImage, fetchNewsListL2, mapNewsItem } from '../../../api'
import FavoriteButton from './FavoriteButton.vue'
import ShareButton from './ShareButton.vue'

export default {
  name: 'ChannelTwoNews',
  components: { FavoriteButton, ShareButton },
  props: {
    categoryId: { type: [Number, String], default: null },
    excludeNewsIdList: { type: Array, default: () => [] }
  },
  data() {
    return {
      bannerImg: '',
      bannerLink: '',
      bannerShowTag: 0,
      loadIcon: require('../channel-two/img/FigmaDDSSlicePNGb212023b2c0c6c18e49d7afd472dbd20.png'),
      allNews: [],
      page: 1,
      pageSize: 10,
      hasMore: true,
      loading: false,
      DEFAULT_IMAGE: 'https://image.cbrand.com.cn/default/2026/10/AA38368160C540F19F19189B1D3A82AE.png'
    }
  },
  computed: {
    visibleNews() {
      return this.allNews
    },
    visibleBlocks() {
      return this.buildBlocks(this.visibleNews)
    }
  },
  watch: {
    categoryId(newVal) {
      if (newVal) {
        // categoryId 变化时重置并加载
        this.page = 1
        this.allNews = []
        this.hasMore = true
        this.fetchNews()
      }
    },
    excludeNewsIdList(newVal) {
      // 排除列表变化时，只有当有值时才重新加载
      if (newVal && newVal.length > 0) {
        this.page = 1
        this.allNews = []
        this.hasMore = true
        this.fetchNews()
      }
    }
  },
  created() {
    // 页面创建时加载数据
    if (this.categoryId) {
      this.loadBanner()
      this.fetchNews()
    }
  },
  methods: {
    handleImageError(event, originalUrl, itemId) {
      console.warn(`图片加载失败：${originalUrl}，切换为默认图片`)
      event.target.src = this.DEFAULT_IMAGE
      const item = this.allNews.find(i => i.id === itemId)
      if (item) {
        item.error = true
        item.isLoading = false
      }
      event.target.src = this.DEFAULT_IMAGE
    },
    handleImageLoad(itemId) {
      const item = this.allNews.find(i => i.id === itemId)
      if (item) {
        item.loaded = true
        item.isLoading = false
      }
    },
    resetAndFetch() {
      this.page = 1
      this.allNews = []
      this.hasMore = true
      this.fetchNews()
    },
    async fetchNews() {
      if (this.loading || !this.categoryId) return
      this.loading = true
      try {
        const params = {
          categoryId: this.categoryId,
          pageNum: this.page,
          pageSize: this.pageSize
        }
        // 如果 excludeNewsIdList 有数据，添加到参数中
        if (this.excludeNewsIdList && this.excludeNewsIdList.length > 0) {
          params.excludeNewsIdList = this.excludeNewsIdList
          console.log('[ChannelTwoNews] excludeNewsIdList:', this.excludeNewsIdList, 'params:', params)
        } else {
          console.log('[ChannelTwoNews] excludeNewsIdList is empty:', this.excludeNewsIdList, 'params:', params)
        }
        const { list } = await fetchNewsListL2(params)
        const mapped = list.map(mapNewsItem)
        console.log('[ChannelTwoNews] fetched news:', mapped)
        // 添加图片加载状态
        mapped.forEach(item => {
          item.loaded = false
          item.isLoading = true
          item.error = false
           if (!item.img) {
            item.loaded = true
            item.isLoading = false
          }
        })
        if (this.page === 1) {
          this.allNews = mapped
        } else {
          this.allNews = this.allNews.concat(mapped)
        }
        this.hasMore = mapped.length === this.pageSize
        this.page += 1
      } catch (e) {
        console.error('新闻加载失败', e)
      } finally {
        this.loading = false
      }
    },
    buildBlocks(list) {
      const blocks = []
      const rowSize = 2
      const bannerPosition = 6 // 第 6 条（3 行）后插入横幅
      let bannerInserted = false

      for (let i = 0; i < list.length; i += rowSize) {
        blocks.push({
          type: 'row',
          items: list.slice(i, i + rowSize)
        })

        // 满足 3 行后插入横幅，且只插入一次
        if (!bannerInserted && i + rowSize >= bannerPosition && this.bannerImg) {
          blocks.push({ type: 'banner' })
          bannerInserted = true
        }
      }

      // 新闻不足 3 行时，在尾部插入一次横幅
      if (!bannerInserted && this.bannerImg) {
        blocks.push({ type: 'banner' })
      }

      return blocks
    },
    loadMore() {
      this.fetchNews()
    },
    formatTime(timeStr) {
      if (!timeStr) return timeStr
      const now = new Date()
      const time = new Date(timeStr)
      const diffMs = now.getTime() - time.getTime()
      const diffSecs = Math.floor(diffMs / 1000)
      const diffMins = Math.floor(diffSecs / 60)
      const diffHours = Math.floor(diffMins / 60)
      const diffDays = Math.floor(diffHours / 24)

      if (diffDays > 0) {
        return `${diffDays}天前`
      } else if (diffHours > 0) {
        return `${diffHours}小时前`
      } else if (diffMins > 0) {
        return `${diffMins}分钟前`
      } else {
        return '刚刚'
      }
    },
    goDetail(item) {
      if (item && item.newsCode) {
        window.open(`/zp/a/${item.newsCode}`, '_blank')
      }
    },
    getSource(source) {
      if (!source) return ''
      const truncated = source.split('|')[0]
      return this.truncateSevenChars(truncated)
    },
    truncateSevenChars(str) {
      if (!str) return ''
      if (str.length <= 7) return str
      return str.slice(0, 7) + '...'
    },
    goBannerLink() {
      if (!this.bannerLink) return
      window.open(this.bannerLink, '_blank')
    },
    async loadBanner() {
      const list = await fetchAdDetails('cate_t2_a_banner')
      const ad = (list || [])[0] || {}
      if (ad.imageUrl) {
        this.bannerImg = resolveAdImage(ad.imageUrl)
      }
      this.bannerLink = ad.turnUrl || ''
      this.bannerShowTag = ad.isShowTag || 0
    }
  }
}
</script>

<style scoped>
.channel-two-news {
  width: 1400px;
  margin: 0 auto;
}

.news-blocks {
  display: flex;
  flex-direction: column;
  gap: 34px;
}

/* 一行两个 */
.news-row {
  display: flex;
  gap: 34px;
}

.news-item {
  width: 683px;
  height: 178px;
  background-color: rgba(245, 245, 247, 1);
  display: flex;
  overflow: hidden;
  transition: all 0.2s ease;
}

.news-image-wrap {
  position: relative;
  cursor: pointer;
  width: 315px;
  height: 177px;
  overflow: hidden;
  border-radius: 4px;
  margin-right: 15px;
}

.news-item:hover {
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.news-thumb {
  width: 315px;
  height: 177px;
  object-fit: cover;
  flex-shrink: 0;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 1;
  transition: opacity 0.3s ease;
}

/* 加载中状态 */
.img-loading {
  opacity: 0.3;
}

/* 图片占位符 - 居中显示 */
.img-placeholder,
.img-default {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  color: #999;
  z-index: 1;
}

.news-content {
  flex: 1;
  min-width: 0;
  padding: 12px 15px 0 25px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.no-image .news-content {
  padding: 14px 24px 2px 25px;
}

.no-image .news-desc {
  /* 无图标题由两行变为一行，用外边距补偿行高差（32px），保持描述位置不变 */
  margin-top: 7px;
  height: 56px;
}

.news-title {
  font-size: 18px;
  color: #333;
  line-height: 32px;
  margin: 0 0 9px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  transition: color 0.2s;
}

.news-item:hover .news-title {
  color: rgba(0, 0, 0, 1);
}

/* 无图时标题只显示一行 */
.no-image .news-title {
  -webkit-line-clamp: 1;
  line-clamp: 1;
}

.news-thumb {
  width: 315px;
  height: 177px;
  object-fit: cover;
  flex-shrink: 0;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 1;
  transition: opacity 0.3s ease;
}

.news-title {
  cursor: pointer;
}

.news-desc {
  /* height: 56px; */
  font-size: 14px;
  color: #666;
  line-height: 28px;
  margin: 1px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.news-meta {
  display: flex;
  align-items: center;
  font-size: 14px;
  margin: 12px 0 12px;
}



.news-category {
  max-width: 138px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: rgba(102, 102, 102, 1);
}

.news-time {
  color: rgba(102, 102, 102, 1);
}

.news-actions {
  display: flex;
  align-items: center;
  margin-left: auto;
}

.action-item {
  display: flex;
  align-items: center;
  margin-left: 25px;
  font-size: 14px;
  color:#666;
  cursor: pointer;
}

.action-item:hover {
  color: #C00513;
}

.action-icon {
  width: 14px;
  height: 14px;
  margin-right: 4px;
  object-fit: contain;
}

/* 横幅 */
.banner-wrap {
  width: 1400px;
  height: 120px;
  cursor: pointer;
  overflow: hidden;
  position: relative;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.ad-tag {
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 0 4px 0 4px;
  line-height: 1.5;
}

/* 加载更多 */
.load-more {
  width: 155px;
  height: 34px;
  margin: 40px auto 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  color: rgba(102, 102, 102, 1);
  transition: color 0.2s;
}

.load-more:hover {
  color: rgba(192, 5, 19, 1);
}

.load-icon {
  width: 24px;
  height: 25px;
  margin-right: 6px;
  object-fit: contain;
}

/* 没有更多 */
.no-more {
  margin: 40px auto 0;
  text-align: center;
  color: #999;
  font-size: 14px;
}
</style>
